import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide, { SlideProps } from '@mui/material/Slide';
import MuiAlert, { AlertProps, AlertColor } from '@mui/material/Alert';

interface Props {
    className?: string
    alertClassName?: string
    message: string
    open: boolean
    handleClose?: () => null
    position?: {vertical: 'top' | 'bottom', horizontal: 'center' | 'left' | 'right'}
    alertSeverity?: AlertColor
    autoHideDuration?: number

}

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((
  props,
  ref,
) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

const Toast = (props: Props) => {
  const {
    message, open,
    className = undefined,
    alertClassName = undefined,
    handleClose = () => null,
    position = { vertical: 'top', horizontal: 'center' },
    alertSeverity = 'info',
    autoHideDuration = 2000,  
  } = props;

  return (
    <Snackbar
      anchorOrigin={position}
      className={className ?? ''}
      open={open}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      message={message}
      key={SlideTransition.name}
      autoHideDuration={autoHideDuration}
    >
      <Alert className={`toast_msg ${alertClassName}`} severity={alertSeverity}>{message}</Alert>
    </Snackbar>
  );
};

export default Toast;
